import React from "react";
import Media from "react-media";
import { HeaderDesktop } from "../../../components/header/desktop/HeaderDesktop";
import { HeaderMobile } from "../../../components/header/mobile/HeaderMobile";
import { ProgressBar } from "../../../components/progress-bar/ProgressBar";
import { Button, TextField } from "@material-ui/core";
import { ActivateDevState } from "../../../states/ActivateDevState";
import { Route } from "react-router-dom";
import { createRef } from "react";
import { GoogleTagManagerService } from "../../../services/analitycs/GoogleTagManagerService";
import $ from "jquery";
import { MposWebPortalApi } from "../../../services/api/MposWebPortalApi";
import { HTTPResponses } from "../../../models/HTTPResponses";
import "./ActivateDev.scss";

export class ActivateDev extends React.Component<any, ActivateDevState> {
  emailInputRef: any;
  private ua = navigator.userAgent.toLowerCase();
  private isAndroid = this.ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
  constructor(props: any) {
    super(props);
    this.state = {
      emailValue: "",
      emailError: false,
      emailErrorText: "Indirizzo email non valido",
      buttonDisabled: true,
    };

    this.handleEmailChanges = this.handleEmailChanges.bind(this);
    this.handleMailKeyDown = this.handleMailKeyDown.bind(this);

    this.emailInputRef = createRef();
  }

  private static renderDesktopHeader(): JSX.Element {
    return <HeaderDesktop showBack={true} showLogout={false} showTitle={true} title={"Abilita utenza sviluppatore"} />;
  }

  private static renderMobileHeader(): JSX.Element {
    return <HeaderMobile showBack={true} showLogout={false} showTitle={true} title={"Abilita utenza sviluppatore"} />;
  }

  private handleEmailChanges(event: any) {
    this.setState({ emailValue: event.target.value, emailError: false, emailErrorText: "Indirizzo email non valido" });
  }

  private handleConfirm(history: any) {
    MposWebPortalApi.getInstance()
      .addDeveloper(this.state.emailValue)
      .subscribe((result) => {
        switch (result) {
          case HTTPResponses.OK:
            history.push("/activateDevResult", {
              isSuccess: true,
              email: this.state.emailValue,
            });
            break;
          case HTTPResponses.NOT_FOUND:
            this.setState({
              emailError: true,
              emailErrorText: "Utenza sviluppatore non trovata con questa email",
              buttonDisabled: true
            });
            break;
          case HTTPResponses.ALREADY_PRESENT:
            this.setState({
              emailError: true,
              emailErrorText: "Esiste già un utenza sviluppatore con questa email",
              buttonDisabled: true
            });
            break;
          case HTTPResponses.KO:
          default:
            history.push("/activateDevResult", {
              isSuccess: false,
              email: this.state.emailValue,
              buttonDisabled: false
            });
            break;
        }
      });
  }

  private validateMailOnBlur() {
    const regex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!regex.test(this.state.emailValue.toLowerCase())) {
      this.setState({ emailError: true });
      this.setState({ buttonDisabled: true });
      GoogleTagManagerService.getInstance().pushCustomError("custom_error", "input", null, "E-mail non valida. Controlla e riprova.", "emailValue", false);
    } else {
      this.setState({ emailError: false });
      this.setState({ buttonDisabled: false });
    }
  }

  private resetEmailField() {
    this.setState({ emailError: false });
  }

  private handleMailKeyDown(event: any) {
    if (event.key === "Enter") {
      console.log("[AddUser] Done clicked!");
      if (this.emailInputRef !== undefined) {
        this.emailInputRef.current.blur();
      }
    }
  }

  render() {
    GoogleTagManagerService.getInstance().pushPageEvent(this.props.history.location.pathname, "Abilita utenza sviluppatore", {});
    return (
      <div id={"main-container-activate-dev"}>
        <ProgressBar value={100} />
        <Media query="(max-width: 1064px)" render={() => ActivateDev.renderMobileHeader()} />
        <Media query="(min-width: 1065px)" render={() => ActivateDev.renderDesktopHeader()} />
        <div className={"activate-dev-container-content"} id={"activate-dev-content"}>
          <div className={"activate-dev-content"}>
            <p className={"activate-dev-title"}>Inserisci l'email</p>
            <p className={"activate-dev-subtitle"}>
              Questa utenza potrà utilizzare i TID (identificativi dei terminali di
              <br className="hide-on-mobile" /> pagamento) del punto vendita e configurarli all’interno della propria
              <br className="hide-on-mobile" /> soluzione software. L’utenza sviluppatore visualizzerà, oltre all’elenco dei
              <br className="hide-on-mobile" /> TID, anche la tua PIVA ed il tuo nome utente.
            </p>
            <TextField
              id={"activate-dev-email-field"}
              label="Email"
              type={"email"}
              inputRef={this.emailInputRef}
              onChange={this.handleEmailChanges}
              value={this.state.emailValue}
              error={this.state.emailError}
              helperText={
                <p className={this.state.emailError ? "activate-dev-email-error" : "activate-dev-email-error activate-dev-label-error-hide"}>
                  {this.state.emailErrorText}
                </p>
              }
              onBlur={() => {
                this.validateMailOnBlur();
              }}
              onFocus={() => {
                this.resetEmailField();
                if (this.isAndroid) {
                  let current = $("#activate-dev-content").height()!;
                  $("#activate-dev-content").height(current);
                }
              }}
              onKeyDown={this.handleMailKeyDown}
            />
          </div>
        </div>
        <div className={"activate-dev-buttons-container"}>
          <p className="activate-dev-note">Nexi non risponde dell’eventuale utilizzo improprio dei TID da parte di questa utenza né di eventuali danni
            <br className="hide-on-mobile" /> correlati, in qualsiasi modo, all’applicazione ed in generale al software fornito dallo stesso sviluppatore.
          </p>
          <Route
            render={({ history }) => {
              return (
                <Button id={"activate-dev-go-to-next-step-button"} type={"button"} disabled={this.state.buttonDisabled} onClick={() => this.handleConfirm(history)}>
                  AVANTI
                </Button>
              );
            }}
          />
        </div>
      </div>
    );
  }
}
